module.exports = __webpack_public_path__ + "img/ic-media-inactive.a7ac4ee1.svg";